export type CategoryKey = "dorm" | "classroom" | "desk" | "chat" | "gossip";

export interface CategoryMeta {
  key: CategoryKey;
  name: string;
  en: string;
  emoji: string;
  desc: string;
}

export const categories: CategoryMeta[] = [
  { key: "dorm", name: "宿舍迷惑", en: "宿舍生活搞笑爆料", emoji: "🛏️", desc: "熄灯后的迷惑行为大赏" },
  { key: "classroom", name: "课堂社死", en: "课堂同学社死现场", emoji: "📖", desc: "讲台上下的社死名场面" },
  { key: "desk", name: "同桌奇葩", en: "校园同桌奇葩事", emoji: "🪑", desc: "你那离谱又可爱的同桌" },
  { key: "chat", name: "群聊翻车", en: "班级群聊翻车合集", emoji: "📱", desc: "手滑与撤回失败的惨案" },
  { key: "gossip", name: "课间八卦", en: "课间八卦聚集地", emoji: "👀", desc: "走廊上的瓜田速递" },
];

export interface Story {
  id: number;
  category: CategoryKey;
  title: string;
  excerpt: string;
  content: string[];
  tags: string[];
  views: number;
  likes: number;
  comments: number;
  author: string;
  time: string;
  reaction: string;
}

export const stories: Story[] = [
  {
    id: 1,
    category: "dorm",
    title: "室友深夜宣布要「断碳水减肥」，结果凌晨在被窝里啃泡面",
    excerpt: "半夜两点，上铺传来塑料包装声。我打开手电一照，这位减肥的兄弟正叼着泡面，眼神坚定得像在偷吃炸药。",
    content: [
      "室友扬言晚上十点后坚决不碰碳水，还发了朋友圈立誓。结果凌晨两点，我在黑暗中被一阵窸窣声吵醒。",
      "打开手机手电往上一照，他正趴在被窝里，就着手机屏幕光悄咪咪啃一包红烧牛肉面，抬头看到我时，硬是面无表情地把面又嗦了一口。",
      "第二天他神采奕奕地说自己昨晚「忍住了」。嗯，你忍住的是被发现的恐惧吧。",
    ],
    tags: ["宿舍生活", "减肥flag", "深夜觅食"],
    views: 32000,
    likes: 2100,
    comments: 186,
    author: "夜猫子宿管",
    time: "3小时前",
    reaction: "😂",
  },
  {
    id: 2,
    category: "chat",
    title: "班长在班级群想喊话「明天交作业」，结果艾特成了教务处主任",
    excerpt: "班长本想提醒大家交作业，手一抖艾特了全年级最凶的主任，还把作业截图发错群，当场原地解散。",
    content: [
      "班长为了催作业，认认真真把催收文案写好后发到了班级群，可艾特对象不知怎么就变成了教务处主任。",
      "更社死的是，附带的「未交名单」截图直接暴露了几个天天摸鱼的同学，群里瞬间安静如鸡。",
      "事后班长改了好几次名，但主任那句「请这位同学周一来讲台述职」成了全班这个月最大的笑料。",
    ],
    tags: ["班级群聊", "手滑翻车", "教务处"],
    views: 28900,
    likes: 1800,
    comments: 154,
    author: "群聊目击者",
    time: "5小时前",
    reaction: "🤣",
  },
  {
    id: 3,
    category: "classroom",
    title: "被点名回答问题，站起来三秒说了句「老师这个我熟」，然后卡住了",
    excerpt: "前桌刚被叫起来就自信满满喊了句『这个我熟』，全班安静，老师眼神一亮，结果他憋了半天一个字都蹦不出来。",
    content: [
      "数学老师突然点了那位上课总在抽屉里看小说的同桌，他唰地站起来，脱口而出「老师这个我熟」。",
      "老师眼睛一亮，全班也投来期待的目光。然后他就像被按了暂停键，脸从白到红，从红到紫。",
      "最后还是后桌悄声提示，他才挤牙膏似的憋出半个答案。坐下后他整整一节课都不敢抬头，桌下的漫画也不敢再碰。",
    ],
    tags: ["课堂社死", "被点名", "现场翻车"],
    views: 41500,
    likes: 3300,
    comments: 312,
    author: "后排吃瓜",
    time: "1小时前",
    reaction: "😆",
  },
  {
    id: 4,
    category: "desk",
    title: "同桌每天给我传小纸条，打开全是「帮我看看老师讲哪一页了」",
    excerpt: "我一直以为同桌想跟我交流感情，直到第N张纸条上写着：这页讲完了没，我要拍照发我妈报平安。",
    content: [
      "同桌是个话少的人，唯一爱好就是上课传纸条。我满怀期待地打开，上面是清秀的三个大字「讲哪页了」。",
      "后来纸条越来越有创意：「老师笑了是不是要下课了」「讲完了发我一张板书，我妈要检查」。",
      "我终于明白，他那不是想跟我交朋友，是把我当成人形课代表提醒器。",
    ],
    tags: ["同桌", "上课摸鱼", "传纸条"],
    views: 22600,
    likes: 1450,
    comments: 98,
    author: "被依赖的课代表",
    time: "6小时前",
    reaction: "😅",
  },
  {
    id: 5,
    category: "gossip",
    title: "图书馆那个天天占座却不看书的男生，终于暴露了身份",
    excerpt: "每次去图书馆都有人用一摞书占着最好的座位，人却不见踪影。上周终于破案，人家是去隔壁自习室睡觉的。",
    content: [
      "图书馆靠窗第二排的黄金座位，常年被一摞《考研英语》占着，坐的人却神龙见首不见尾。",
      "上周保洁阿姨终于憋不住，让我帮忙把「占座专用书」收走，结果一挪开，下面压着张「本人占座，见谅」的小纸条。",
      "破案后才知，这位同学把书一放就去隔壁自习室趴着睡午觉，睡醒了再回来。舍友感叹：人家的占座，是占了个寂寞。",
    ],
    tags: ["课间八卦", "图书馆", "占座"],
    views: 19800,
    likes: 1200,
    comments: 76,
    author: "图书管理员",
    time: "8小时前",
    reaction: "🙃",
  },
  {
    id: 6,
    category: "dorm",
    title: "宿舍里四个人，硬是把「一起点外卖」过成了谍战片",
    excerpt: "四个室友互相都想让对方去拿外卖，最后达成协议剪刀石头布，输的连拿四个人的，结果外卖小哥在楼下等了二十分钟。",
    content: [
      "我们宿舍点外卖永远是一场博弈，四个人都在床上，谁也不想下楼，就开始了漫长的『你先动我先动』。",
      "最终通过公平公正的石头剪刀布，某位手气欠佳的老哥含泪包揽全部四份外卖。",
      "他下楼前还不忘大喊：你们等着，我这就去把外卖小哥处好关系，让他以后只把餐送我们门口！",
    ],
    tags: ["宿舍生活", "外卖", "宿舍日常"],
    views: 35800,
    likes: 2600,
    comments: 240,
    author: "宿舍老大",
    time: "2小时前",
    reaction: "😂",
  },
  {
    id: 7,
    category: "classroom",
    title: "英语老师叫错名字第100次后，全班终于开始认真听写了",
    excerpt: "老师点人回答总爱叫错名，直到那回把男生叫成隔壁班女生的名字，全班的沉默震耳欲聋。",
    content: [
      "我们的英语老师有个祖传技能：永远叫不对学生名字，从开学到现在几乎每个人都『被改名』过。",
      "直到上周，他把班里一米八的体育生小张叫成了隔壁班文艺委员的名字，那一瞬间教室里安静得能听见粉笔灰落地。",
      "为了不再被『改名』，全班从此对老师的提问格外认真，毕竟谁也不想当那个被全网吃瓜的名场面主角。",
    ],
    tags: ["课堂", "老师", "社死"],
    views: 27000,
    likes: 1650,
    comments: 132,
    author: "认真听讲中",
    time: "9小时前",
    reaction: "😳",
  },
  {
    id: 8,
    category: "chat",
    title: "有人在班群里回了句「收到」，被老师追问了半小时「收到什么」",
    excerpt: "通知还没发完就有人秒回「收到」，老师当场怒问：我话都没说完你收到什么？全班笑疯。",
    content: [
      "班主任在群里发了一段超长通知，刚打到一半就被某个手速惊人的同学秒回「收到」。",
      "老师瞬间破防，连发三条追问：「我话都没说完，你收到什么了？」「你在收到谁？」「重新给我看一遍再回！」",
      "那位同学在撤回的边缘疯狂试探，最后还是老实回了句「老师我收到您的严厉」，才勉强保住了这个月的群昵称。",
    ],
    tags: ["班级群聊", "收到", "班主任"],
    views: 31200,
    likes: 2400,
    comments: 207,
    author: "手速冠军",
    time: "4小时前",
    reaction: "😄",
  },
  {
    id: 9,
    category: "desk",
    title: "我同桌的橡皮，一个学期集齐了全班的名牌",
    excerpt: "同桌的橡皮上写满了不同名字，说是借出去就写上记号防丢，结果一学期下来，它成了全班的『传家宝』。",
    content: [
      "同桌为了找回丢失的橡皮，发明了『签名橡皮』：谁借走就在橡皮上写名字做记号。",
      "于是这块橡皮开始了奇妙漂流，从一个座位传到另一个座位，名字越写越多。",
      "学期末它被传回来时，上面密密麻麻挤着三十多个名字，连隔壁班都有。这块橡皮，堪称班级团魂的物理载体。",
    ],
    tags: ["同桌", "橡皮", "班级趣事"],
    views: 17500,
    likes: 980,
    comments: 61,
    author: "橡皮守护者",
    time: "10小时前",
    reaction: "🤭",
  },
  {
    id: 10,
    category: "gossip",
    title: "运动会那天，广播站把「加油稿」念成了「检讨书」",
    excerpt: "广播员一时手滑把稿子拿反，对着全校念起了一封检讨书，操场瞬间安静，随后笑成一片。",
    content: [
      "校运会广播站日常播报各班加油稿，气氛热烈。谁知广播员一紧张，把刚没收上来的某位同学『检讨书』当成了加油稿。",
      "『各位同学，今天我要在此深刻反思……』声音一出，全场从沸腾秒变寂静，又瞬间炸开大笑。",
      "那位当事同学在跑道上捂脸狂奔，广播站站长在后头追着夺话筒，场面一度成为全运会最佳名场面。",
    ],
    tags: ["运动会", "广播站", "名场面"],
    views: 40200,
    likes: 3100,
    comments: 268,
    author: "操场群众",
    time: "30分钟前",
    reaction: "🤣",
  },
  {
    id: 11,
    category: "dorm",
    title: "宿管阿姨查寝时，我们宿舍的「人体模特」差点上热搜",
    excerpt: "室友为了装『床上有人』，用枕头摆了个假人，结果被子没盖好露出一只拖鞋，宿管阿姨当场看破。",
    content: [
      "室友为了营造『床上睡着人』的假象，精心用枕头和被子堆了个『人体模特』。",
      "谁知宿管阿姨查寝火眼金睛，一眼就看出那只露在外面的拖鞋不对劲，当场拆穿：『装睡的人叫不醒，装人的被可不行。』",
      "从此我们宿舍的『人体模特』成了楼道里的传说，甚至有人专门跑来围观这尊『民间艺术』。",
    ],
    tags: ["宿舍", "宿管", "查寝"],
    views: 36600,
    likes: 2750,
    comments: 219,
    author: "宿舍艺术团",
    time: "7小时前",
    reaction: "😹",
  },
  {
    id: 12,
    category: "classroom",
    title: "演讲忘词，临时改成「给同学们朗读课文」，全程声情并茂",
    excerpt: "课前三分钟演讲，小陈讲到一半突然忘词，急中生智掏出语文书就开始朗诵《岳阳楼记》，把台下都听傻了。",
    content: [
      "语文课前的三分钟演讲，轮到小陈时他准备充分，结果讲着讲着大脑一片空白，现场陷入尴尬的安静。",
      "就在大家以为他要下台时，他淡定地从书包里掏出一本语文书，开始了饱含深情的《岳阳楼记》朗诵。",
      "『先天下之忧而忧，后天下之乐而乐！』他字正腔圆、手势到位，硬是把即兴救场变成了全场最佳，掌声经久不息。",
    ],
    tags: ["课堂社死", "演讲", "急中生智"],
    views: 24500,
    likes: 1520,
    comments: 108,
    author: "语文课代表",
    time: "11小时前",
    reaction: "🙌",
  },
  {
    id: 13,
    category: "desk",
    title: "同桌的笔记本里，画满了我们全班同学的下课名场面",
    excerpt: "我一直以为同桌上课在记笔记，直到偷瞄发现，他把全班同学的日常画成了连载漫画。",
    content: [
      "同桌的笔记本从外表看是正经笔记，直到我某次不小心看见内页，发现全是惟妙惟肖的简笔画小人。",
      "有前桌趴桌睡着的名场面，有班长讲台训话的威严背影，还有我自己上课打哈欠的『精美写真』。",
      "这本『班级史记』传遍全班后，同桌被当场升职为班级御用画师，人人都排队求他画自己的『帅照』。",
    ],
    tags: ["同桌", "漫画", "班级史记"],
    views: 21400,
    likes: 1390,
    comments: 95,
    author: "被画本人",
    time: "12小时前",
    reaction: "😎",
  },
  {
    id: 14,
    category: "gossip",
    title: "食堂阿姨的「手抖绝技」，被我们班吐槽上了表白墙",
    excerpt: "每次打菜阿姨都抖掉半勺肉，直到有同学发现：只要喊声阿姨你手真稳，菜量立刻翻倍。",
    content: [
      "食堂打菜的阿姨深谙『手抖之道』，一勺肉能抖掉半勺，无数干饭人扼腕叹息。",
      "直到有位机灵的同学无意中发现，只要真诚地夸一句『阿姨今天手真稳』，碗里的肉肉眼可见地多了起来。",
      "消息在班里传开，从此食堂队伍里此起彼伏的夸赞声，阿姨乐得直摆手：够了够了，再夸我就要亏本了。",
    ],
    tags: ["课间八卦", "食堂", "干饭人"],
    views: 33100,
    likes: 2500,
    comments: 198,
    author: "干饭冠军",
    time: "1天前",
    reaction: "😋",
  },
];

export const hotRanking: Story[] = [...stories].sort((a, b) => b.views - a.views);